import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Avatar from "antd/lib/avatar/avatar";

const AuthenticationButton = () => {
    const { user } = useAuth0();
    if(user){      
        return <>
        <Avatar style={{ marginRight:'10px'}} src={user.picture}/>
        {(user.given_name+' '+user.family_name).toUpperCase()}
        </>
    }
    else return 'ANONYMOUS'
};

export default AuthenticationButton;